import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import styles from './Login.module.css';

export default function Login() {
  const { user, loading, error, signIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  if (loading) {
    return (
      <div className={styles.container}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Charsoft Command Center</h1>
        <p className={styles.subtitle}>Unified dashboard for app portfolio, revenue, and business management.</p>

        {error && <p className={styles.error}>{error}</p>}

        <button onClick={signIn} className={styles.signInBtn}>
          Sign in with Google
        </button>

        <p className={styles.notice}>Restricted to charlene@charsoft.com</p>
      </div>
    </div>
  );
}
